import { AbstractControl } from '@angular/forms';
import { rawModes } from '../constants/constants';

export interface AbstractControlWarn extends AbstractControl {
    warnings: any;
}

export function smallBatchSizeCheck(rawMode: string, batchSize: any): boolean {
    const noCommas = isNaN(batchSize) ? batchSize.replace(/,/g, '') : batchSize;
    return (rawMode?.includes(rawModes.Incremental.name) ||
        rawMode === rawModes.Replace.name ||
        rawMode === rawModes.Append.name) &&
        +noCommas < 10000000 &&
        +noCommas >= 1
        ? true
        : false;
}

export function batchSizeErrorMessage(batchSize: any): string {
    const noCommas = isNaN(batchSize) ? batchSize.replace(/,/g, '') : batchSize;

    return noCommas && +noCommas < 1
        ? 'Batch size cannot be less than 1'
        : 'Batch Size is required and needs to be a number';
}
